import { Action } from "./action";
import { Environment } from "./environment";
import { OrderResponse } from "./orderResponse";
import { OrderTypeConfiguration } from "./orderTypeConfiguration";
import { WriteStatus } from "./writeStatus";

export interface OrderStepFunctionContainer {
  operation?: OrderStepFunctionContainer.OperationEnum;
  dynamoWrite?: WriteStatus;
  openSearchWrite?: WriteStatus;
  action?: Action;
  order?: OrderResponse;
  reinstateOrder?: OrderResponse;
  orderTypes?: Array<OrderTypeConfiguration>;
  environment?: Environment;
  transactionSource?: OrderStepFunctionContainer.TransactionSourceEnum;
  correlationId?: string;
  isQueueEvent?: boolean;
}

export namespace OrderStepFunctionContainer {
  export type OperationEnum = "OrderCreate" | "OrderPatch";
  export const OperationEnum = {
    OrderCreate: "OrderCreate" as OperationEnum,
    OrderPatch: "OrderPatch" as OperationEnum,
  };
  export type TransactionSourceEnum =
    | "OrderManagement"
    | "Bulk"
    | "PatientMedications";
  export const TransactionSourceEnum = {
    OrderManagement: "OrderManagement" as TransactionSourceEnum,
    Bulk: "Bulk" as TransactionSourceEnum,
    PatientMedications: "PatientMedications" as TransactionSourceEnum,
  };
}



// WEBPACK FOOTER //
// ./src/models/order-management/orderStepFunctionContainer.ts